<template>
    <div class="np-detail-section">
        <div class="np-detail-section__title np-detail-section__title--no-border"><span>3. Prices</span>
        <button type="button" class="btn btn--green" @click="isOpenSeasons = true">
            <svg width="1em" height="1em" class="icon icon-list ">
            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-list"></use>
            </svg><span>Seasons</span>
        </button>
        </div>
        <div class="np-detail-season" v-if="seasons.find(item => item.active)">
        <div class="np-detail-season__header">
            <div class="np-detail-season__filters">
            <div class="np-detail-season__filters__side">
                <div class="form-control-group"><span class="form-control-label">Choose Season</span>
                <div :class="['select-wrapper', 'select-wrapper--xl', { 'is-active' : selects.seasons }]" @click="changeSelects('seasons')">
                    <div class="select-trigger"><span class="select-trigger__name"><b>{{seasons.find(item => item.active).name}}</b> <i>{{seasons.find(item => item.active).dateFrom}} - {{seasons.find(item => item.active).dateTo}}</i></span><span class="select-trigger__icon">
                        <svg width="1em" height="1em" class="icon icon-chevron ">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                        </svg></span></div>
                        <div class="select-body">
                            <div class="select-inner">
                                <div
                                    v-for="item in seasons"
                                    :key="item.id"
                                    :class="['select-option', {'is-selected' : item.id === seasons.find(item => item.active).id}]"
                                    @click="seasons = seasons.map(season => item.id === season.id ? {...season, active: true} : {...season, active: false})"
                                    ><span class="select-option__name"><b>{{item.name}}</b> <i>{{item.dateFrom}} - {{item.dateTo}}</i></span></div>
                            </div>
                        </div>
                </div>
                </div>
                <button type="button" data-popover="Copy rates from another season" class="btn btn--green btn--sm-squared btn--popover" @click="copySeason = true">
                <svg width="1em" height="1em" class="icon icon-copy ">
                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                </svg>
                </button>
            </div>
            </div>
        </div>
        <div class="np-detail-season__inner">
             <div class="season-box-wrap_details">
            <div class="season-box-wraper">
                <div class="season-box__title"><span>Cost Foreign</span>
                </div>
                <div class="js-scrollbar">
                <div class="season-box__table">
                    <div class="season-box__table__header">
                    <div class="season-box__table__main"><span>Age</span></div>
                    <div class="season-box__table__currency"><span>Currency </span></div>
                    <div class="season-box__table__price"><span>1 Pax</span></div>
                    <div class="season-box__table__price"><span>2 Pax</span></div>
                    <div class="season-box__table__price"><span>3 Pax</span></div>
                    <div class="season-box__table__price"><span>4 Pax</span></div>
                    <div class="season-box__table__price"><span>5 Pax</span></div>
                    <div class="season-box__table__price"><span>6 Pax</span></div>
                    <div class="season-box__table__price"><span>7 Pax</span></div>
                    <div class="season-box__table__price"><span>8 Pax</span></div>
                    </div>
                    <SeasonBoxLong
                        @closeSelects="changeSelects"
                        :title="'Adult Foreign'"
                        :placeholder="'1000'"
                        :currency="data.adultForCur"
                        :value1="data.adultFor1"
                        :value2="data.adultFor2"
                        :value3="data.adultFor3"
                        :value4="data.adultFor4"
                        :value5="data.adultFor5"
                        :value6="data.adultFor6"
                        :value7="data.adultFor7"
                        :value8="data.adultFor8"
                        @changeValue="changeValue"
                        :name1="'adultFor1'"
                        :name2="'adultFor2'"
                        :name3="'adultFor3'"
                        :name4="'adultFor4'"
                        :name5="'adultFor5'"
                        :name6="'adultFor6'"
                        :name7="'adultFor7'"
                        :name8="'adultFor8'"
                        :nameCur="'adultForCur'"
                        @changeCurrency="changeCurrency"
                        />
                    <SeasonBoxLong @closeSelects="changeSelects" :title="'Teenager Foreign'" :placeholder="'1000'" :currency="data.teenForCur"

                        :value1="data.teenFor1"
                        :value2="data.teenFor2"
                        :value3="data.teenFor3"
                        :value4="data.teenFor4"
                        :value5="data.teenFor5"
                        :value6="data.teenFor6"
                        :value7="data.teenFor7"
                        :value8="data.teenFor8"

                        @changeValue="changeValue"

                        :name1="'teenFor1'"
                        :name2="'teenFor2'"
                        :name3="'teenFor3'"
                        :name4="'teenFor4'"
                        :name5="'teenFor5'"
                        :name6="'teenFor6'"
                        :name7="'teenFor7'"
                        :name8="'teenFor8'"
                        :nameCur="'teenForCur'"
                        @changeCurrency="changeCurrency" />
                    <SeasonBoxLong @closeSelects="changeSelects" :title="'Child Foreign'" :placeholder="'1000'" :currency="data.childForCur"

                        :value1="data.childFor1"
                        :value2="data.childFor2"
                        :value3="data.childFor3"
                        :value4="data.childFor4"
                        :value5="data.childFor5"
                        :value6="data.childFor6"
                        :value7="data.childFor7"
                        :value8="data.childFor8"

                     @changeValue="changeValue"

                        :name1="'childFor1'"
                        :name2="'childFor2'"
                        :name3="'childFor3'"
                        :name4="'childFor4'"
                        :name5="'childFor5'"
                        :name6="'childFor6'"
                        :name7="'childFor7'"
                        :name8="'childFor8'"
                        :nameCur="'childForCur'"
                     @changeCurrency="changeCurrency" />
                </div>
                </div>
            </div>

            <div class="season-box-wraper">
                <div class="season-box__title"><span>Cost Resident</span>
                </div>
                <div class="js-scrollbar">
                <div class="season-box__table">
                    <div class="season-box__table__header">
                    <div class="season-box__table__main"><span>Age</span></div>
                    <div class="season-box__table__currency"><span>Currency </span></div>
                    <div class="season-box__table__price"><span>1 Pax</span></div>
                    <div class="season-box__table__price"><span>2 Pax</span></div>
                    <div class="season-box__table__price"><span>3 Pax</span></div>
                    <div class="season-box__table__price"><span>4 Pax</span></div>
                    <div class="season-box__table__price"><span>5 Pax</span></div>
                    <div class="season-box__table__price"><span>6 Pax</span></div>
                    <div class="season-box__table__price"><span>7 Pax</span></div>
                    <div class="season-box__table__price"><span>8 Pax</span></div>
                    </div>
                    <SeasonBoxLong @closeSelects="changeSelects" :title="'Adult Resident'" :placeholder="'1000'" :currency="data.adultExpCur"

                        :value1="data.adultExp1"
                        :value2="data.adultExp2"
                        :value3="data.adultExp3"
                        :value4="data.adultExp4"
                        :value5="data.adultExp5"
                        :value6="data.adultExp6"
                        :value7="data.adultExp7"
                        :value8="data.adultExp8"

                    @changeValue="changeValue"

                        :name1="'adultExp1'"
                        :name2="'adultExp2'"
                        :name3="'adultExp3'"
                        :name4="'adultExp4'"
                        :name5="'adultExp5'"
                        :name6="'adultExp6'"
                        :name7="'adultExp7'"
                        :name8="'adultExp8'"
                        :nameCur="'adultExpCur'"

                     @changeCurrency="changeCurrency" />
                    <SeasonBoxLong @closeSelects="changeSelects" :title="'Teenager Resident'" :placeholder="'1000'" :currency="data.teenExpCur"

                        :value1="data.teenExp1"
                        :value2="data.teenExp2"
                        :value3="data.teenExp3"
                        :value4="data.teenExp4"
                        :value5="data.teenExp5"
                        :value6="data.teenExp6"
                        :value7="data.teenExp7"
                        :value8="data.teenExp8"

                    @changeValue="changeValue"

                        :name1="'teenExp1'"
                        :name2="'teenExp2'"
                        :name3="'teenExp3'"
                        :name4="'teenExp4'"
                        :name5="'teenExp5'"
                        :name6="'teenExp6'"
                        :name7="'teenExp7'"
                        :name8="'teenExp8'"
                        :nameCur="'teenExpCur'"
                    @changeCurrency="changeCurrency" />
                    <SeasonBoxLong @closeSelects="changeSelects" :title="'Child Resident'" :placeholder="'1000'" :currency="data.childExpCur"

                        :value1="data.childExp1"
                        :value2="data.childExp2"
                        :value3="data.childExp3"
                        :value4="data.childExp4"
                        :value5="data.childExp5"
                        :value6="data.childExp6"
                        :value7="data.childExp7"
                        :value8="data.childExp8"

                    @changeValue="changeValue"
                        :name1="'childExp1'"
                        :name2="'childExp2'"
                        :name3="'childExp3'"
                        :name4="'childExp4'"
                        :name5="'childExp5'"
                        :name6="'childExp6'"
                        :name7="'childExp7'"
                        :name8="'childExp8'"
                        :nameCur="'childExpCur'"
                    @changeCurrency="changeCurrency" />
                </div>
                </div>
            </div>
            <div class="season-box-wraper">
                <div class="season-box__title"><span>Cost EA</span>
                </div>
                <div class="js-scrollbar">
                <div class="season-box__table">
                    <div class="season-box__table__header">
                    <div class="season-box__table__main"><span>Age</span></div>
                    <div class="season-box__table__currency"><span>Currency </span></div>
                    <div class="season-box__table__price"><span>1 Pax</span></div>
                    <div class="season-box__table__price"><span>2 Pax</span></div>
                    <div class="season-box__table__price"><span>3 Pax</span></div>
                    <div class="season-box__table__price"><span>4 Pax</span></div>
                    <div class="season-box__table__price"><span>5 Pax</span></div>
                    <div class="season-box__table__price"><span>6 Pax</span></div>
                    <div class="season-box__table__price"><span>7 Pax</span></div>
                    <div class="season-box__table__price"><span>8 Pax</span></div>
                    </div>
                    <SeasonBoxLong @closeSelects="changeSelects" :title="'Adult EA'" :placeholder="'1000'" :currency="data.adultSACur"

                        :value1="data.adultSA1"
                        :value2="data.adultSA2"
                        :value3="data.adultSA3"
                        :value4="data.adultSA4"
                        :value5="data.adultSA5"
                        :value6="data.adultSA6"
                        :value7="data.adultSA7"
                        :value8="data.adultSA8"

                        @changeValue="changeValue"

                        :name1="'adultSA1'"
                        :name2="'adultSA2'"
                        :name3="'adultSA3'"
                        :name4="'adultSA4'"
                        :name5="'adultSA5'"
                        :name6="'adultSA6'"
                        :name7="'adultSA7'"
                        :name8="'adultSA8'"
                        :nameCur="'adultSACur'"
                         @changeCurrency="changeCurrency" />
                    <SeasonBoxLong @closeSelects="changeSelects" :title="'Teenager EA'" :placeholder="'1000'" :currency="data.teenSACur"

                        :value1="data.teenSA1"
                        :value2="data.teenSA2"
                        :value3="data.teenSA3"
                        :value4="data.teenSA4"
                        :value5="data.teenSA5"
                        :value6="data.teenSA6"
                        :value7="data.teenSA7"
                        :value8="data.teenSA8"

                        @changeValue="changeValue"

                        :name1="'teenSA1'"
                        :name2="'teenSA2'"
                        :name3="'teenSA3'"
                        :name4="'teenSA4'"
                        :name5="'teenSA5'"
                        :name6="'teenSA6'"
                        :name7="'teenSA7'"
                        :name8="'teenSA8'"
                         :nameCur="'teenSACur'"
                         @changeCurrency="changeCurrency" />
                    <SeasonBoxLong @closeSelects="changeSelects" :title="'Child EA'" :placeholder="'1000'" :currency="data.childSACur"

                        :value1="data.childSA1"
                        :value2="data.childSA2"
                        :value3="data.childSA3"
                        :value4="data.childSA4"
                        :value5="data.childSA5"
                        :value6="data.childSA6"
                        :value7="data.childSA7"
                        :value8="data.childSA8"

                        @changeValue="changeValue"

                        :name1="'childSA1'"
                        :name2="'childSA2'"
                        :name3="'childSA3'"
                        :name4="'childSA4'"
                        :name5="'childSA5'"
                        :name6="'childSA6'"
                        :name7="'childSA7'"
                        :name8="'childSA8'"
                         :nameCur="'childSACur'"
                        @changeCurrency="changeCurrency" />
                </div>
                </div>
            </div>
            </div>
        </div>
        </div>
         <Seasons @notLeavePopupHandler="data => $emit('notLeavePopupHandler', data)" @errored="$emit('errored')" @deleteModalHandler="data => $emit('deleteModalHandler', data)" :open="isOpenSeasons"  @confirmed="$emit('confirmed')" :title="'Activities'" @close="closeSeasons" :type="'activity'" :user="user"/>
        <div class="modal-wrapper" v-if="copySeason">
                <div class="modal-backdrop"></div>
                <div class="modal-inner">
                    <div class="edit-popup edit-popup--copy-season">
                        <div class="edit-popup__header">
                            <div class="edit-popup__title">
                            <div class="edit-popup__title__icon">
                                <svg width="1em" height="1em" class="icon icon-copy ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                                </svg>
                            </div><span>Copy rates</span>
                            </div>
                            <div class="edit-popup__close" @click="copySeason = false">
                            <svg width="1em" height="1em" class="icon icon-close ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                            </svg>
                            </div>
                        </div>
                        <form action="javascript:void(0)" class="edit-popup__inner">
                            <div class="edit-popup__info">
                            <p>{{seasons.find(item => item.active).name}} <i>{{seasons.find(item => item.active).dateFrom}} - {{seasons.find(item => item.active).dateTo}}</i></p>
                            </div>
                            <div class="edit-popup__side-wrap">
                            <div class="edit-popup__side">
                                <div class="form-control-group"><span class="form-control-label form-control-label-bold">Prices for the <b>"{{seasons.find(item => item.active).name}}"</b> season will be copied from the season:</span>
                                <div :class="['select-wrapper', 'select-wrapper--xl', { 'is-active' : selects.seasonsData }]" @click="changeSelects('seasonsData');">
                                    <div class="select-trigger"><span class="select-trigger__name"><b>{{seasonsData.find(item => item.active).name}}</b> <i>{{seasonsData.find(item => item.active).dateFrom}} - {{seasonsData.find(item => item.active).dateTo}}</i></span><span class="select-trigger__icon">
                                        <svg width="1em" height="1em" class="icon icon-chevron ">
                                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                        </svg></span></div>
                                    <div class="select-body">
                                    <div class="select-inner">
                                        <div
                                            v-for="item in seasonsData"
                                            :key="item.id"
                                            :class="['select-option', {'is-selected' : item.id === seasonsData.find(item => item.active).id}]"
                                            @click="seasonsData = seasonsData.map(season => item.id === season.id ? {...season, active: true} : {...season, active: false})"
                                            ><span class="select-option__name"><b>{{item.name}}</b> <i>{{item.dateFrom}} - {{item.dateTo}}</i></span></div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <button type="submit" class="btn btn--green edit-popup__submit" @click.prevent="copyPriceHandler">
                                <svg width="1em" height="1em" class="icon icon-copy ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                                </svg><span>Copy</span>
                            </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>

    import Seasons from './Seasons'
    import SeasonBox from './SeasonBox'
    import SeasonBoxLong from './SeasonBoxLong'
    import ClipboardJS from 'clipboard'
    import { getSeasonsType, getTanzaniaPriceCopy, createActivityPrice, getTanzaniaPrice } from '@/utilites/api'

    export default {
        data(){
            return {
                isOpenSeasons: false,
                seasons: [],
                seasonsData: [],
                parks: [],
                selects: {
                    seasons: false,
                    seasonsData: false,
                    park: false
                },
                copySeason: false,
                data: {
                    adultSA1: '',
                    adultSA2: '',
                    adultSA3: '',
                    adultSA4: '',
                    adultSA5: '',
                    adultSA6: '',
                    adultSA7: '',
                    adultSA8: '',
                    adultSACur: 'USD',
                    teenSA1: '',
                    teenSA2: '',
                    teenSA3: '',
                    teenSA4: '',
                    teenSA5: '',
                    teenSA6: '',
                    teenSA7: '',
                    teenSA8: '',
                    teenSACur: 'USD',
                    childSA1: '',
                    childSA2: '',
                    childSA3: '',
                    childSA4: '',
                    childSA5: '',
                    childSA6: '',
                    childSA7: '',
                    childSA8: '',
                    childSACur: 'USD',
                    adultFor1: '',
                    adultFor2: '',
                    adultFor3: '',
                    adultFor4: '',
                    adultFor5: '',
                    adultFor6: '',
                    adultFor7: '',
                    adultFor8: '',
                    adultForCur: 'USD',
                    teenFor1: '',
                    teenFor2: '',
                    teenFor3: '',
                    teenFor4: '',
                    teenFor5: '',
                    teenFor6: '',
                    teenFor7: '',
                    teenFor8: '',
                    teenForCur: 'USD',
                    childFor1: '',
                    childFor2: '',
                    childFor3: '',
                    childFor4: '',
                    childFor5: '',
                    childFor6: '',
                    childFor7: '',
                    childFor8: '',
                    childForCur: 'USD',
                    adultExp1: '',
                    adultExp2: '',
                    adultExp3: '',
                    adultExp4: '',
                    adultExp5: '',
                    adultExp6: '',
                    adultExp7: '',
                    adultExp8: '',
                    adultExpCur: 'USD',
                    teenExp1: '',
                    teenExp2: '',
                    teenExp3: '',
                    teenExp4: '',
                    teenExp5: '',
                    teenExp6: '',
                    teenExp7: '',
                    teenExp8: '',
                    teenExpCur: 'USD',
                    childExp1: '',
                    childExp2: '',
                    childExp3: '',
                    childExp4: '',
                    childExp5: '',
                    childExp6: '',
                    childExp7: '',
                    childExp8: '',
                    childExpCur: 'USD'
                }
            }
        },
        props: ['user', 'tanzania', 'save'],
        components: { Seasons, SeasonBox, SeasonBoxLong, ClipboardJS },
        methods: {
            changeSelects(target){
				this.selects = {
                    seasons: false,
                    seasonsData: false,
                    park: false,
                    [target] : !this.selects[target]
				}
                this.$emit('closeSelects')
			},
            closeSeasons(){
                this.isOpenSeasons = false
            },
            updateData(){
                getSeasonsType(this.user.access_token, 'activity')
                .then(res => {
                    this.seasons = res.map((item, index) => index === 0 ? {...item, active: true} : {...item, active: false})
                    this.seasonsData = res.map((item, index) => index === 0 ? {...item, active: true} : {...item, active: false})
                    if(this.tanzania){
                        getTanzaniaPrice(this.user.access_token, this.seasons.find(item => item.active).id, this.tanzania.id)
                        .then(res => {
                            this.data = {
                                adultSA1: res.prices.costEA.adult.prices.price1,
                                adultSA2: res.prices.costEA.adult.prices.price2,
                                adultSA3: res.prices.costEA.adult.prices.price3,
                                adultSA4: res.prices.costEA.adult.prices.price4,
                                adultSA5: res.prices.costEA.adult.prices.price5,
                                adultSA6: res.prices.costEA.adult.prices.price6,
                                adultSA7: res.prices.costEA.adult.prices.price7,
                                adultSA8: res.prices.costEA.adult.prices.price8,
                                adultSACur: res.prices.costEA.adult.currency,
                                teenSA1: res.prices.costEA.teenager.prices.price1,
                                teenSA2: res.prices.costEA.teenager.prices.price2,
                                teenSA3: res.prices.costEA.teenager.prices.price3,
                                teenSA4: res.prices.costEA.teenager.prices.price4,
                                teenSA5: res.prices.costEA.teenager.prices.price5,
                                teenSA6: res.prices.costEA.teenager.prices.price6,
                                teenSA7: res.prices.costEA.teenager.prices.price7,
                                teenSA8: res.prices.costEA.teenager.prices.price8,
                                teenSACur:  res.prices.costEA.teenager.currency,
                                childSA1: res.prices.costEA.child.prices.price1,
                                childSA2: res.prices.costEA.child.prices.price2,
                                childSA3: res.prices.costEA.child.prices.price3,
                                childSA4: res.prices.costEA.child.prices.price4,
                                childSA5: res.prices.costEA.child.prices.price5,
                                childSA6: res.prices.costEA.child.prices.price6,
                                childSA7: res.prices.costEA.child.prices.price7,
                                childSA8: res.prices.costEA.child.prices.price8,
                                childSACur: res.prices.costEA.child.currency,
                                adultFor1: res.prices.costForeign.adult.prices.price1,
                                adultFor2: res.prices.costForeign.adult.prices.price2,
                                adultFor3: res.prices.costForeign.adult.prices.price3,
                                adultFor4: res.prices.costForeign.adult.prices.price4,
                                adultFor5: res.prices.costForeign.adult.prices.price5,
                                adultFor6: res.prices.costForeign.adult.prices.price6,
                                adultFor7: res.prices.costForeign.adult.prices.price7,
                                adultFor8: res.prices.costForeign.adult.prices.price8,
                                adultForCur: res.prices.costForeign.adult.currency,
                                teenFor1: res.prices.costForeign.teenager.prices.price1,
                                teenFor2: res.prices.costForeign.teenager.prices.price2,
                                teenFor3: res.prices.costForeign.teenager.prices.price3,
                                teenFor4: res.prices.costForeign.teenager.prices.price4,
                                teenFor5: res.prices.costForeign.teenager.prices.price5,
                                teenFor6: res.prices.costForeign.teenager.prices.price6,
                                teenFor7: res.prices.costForeign.teenager.prices.price7,
                                teenFor8: res.prices.costForeign.teenager.prices.price8,
                                teenForCur: res.prices.costForeign.teenager.currency,
                                childFor1: res.prices.costForeign.child.prices.price1,
                                childFor2: res.prices.costForeign.child.prices.price2,
                                childFor3: res.prices.costForeign.child.prices.price3,
                                childFor4: res.prices.costForeign.child.prices.price4,
                                childFor5: res.prices.costForeign.child.prices.price5,
                                childFor6: res.prices.costForeign.child.prices.price6,
                                childFor7: res.prices.costForeign.child.prices.price7,
                                childFor8: res.prices.costForeign.child.prices.price8,
                                childForCur:  res.prices.costForeign.child.currency,
                                adultExp1: res.prices.costExpat.adult.prices.price1,
                                adultExp2: res.prices.costExpat.adult.prices.price2,
                                adultExp3: res.prices.costExpat.adult.prices.price3,
                                adultExp4: res.prices.costExpat.adult.prices.price4,
                                adultExp5: res.prices.costExpat.adult.prices.price5,
                                adultExp6: res.prices.costExpat.adult.prices.price6,
                                adultExp7: res.prices.costExpat.adult.prices.price7,
                                adultExp8: res.prices.costExpat.adult.prices.price8,
                                adultExpCur:  res.prices.costExpat.adult.currency,
                                teenExp1: res.prices.costExpat.teenager.prices.price1,
                                teenExp2: res.prices.costExpat.teenager.prices.price2,
                                teenExp3: res.prices.costExpat.teenager.prices.price3,
                                teenExp4: res.prices.costExpat.teenager.prices.price4,
                                teenExp5: res.prices.costExpat.teenager.prices.price5,
                                teenExp6: res.prices.costExpat.teenager.prices.price6,
                                teenExp7: res.prices.costExpat.teenager.prices.price7,
                                teenExp8: res.prices.costExpat.teenager.prices.price8,
                                teenExpCur: res.prices.costExpat.teenager.currency,
                                childExp1: res.prices.costExpat.child.prices.price1,
                                childExp2: res.prices.costExpat.child.prices.price2,
                                childExp3: res.prices.costExpat.child.prices.price3,
                                childExp4: res.prices.costExpat.child.prices.price4,
                                childExp5: res.prices.costExpat.child.prices.price5,
                                childExp6: res.prices.costExpat.child.prices.price6,
                                childExp7: res.prices.costExpat.child.prices.price7,
                                childExp8: res.prices.costExpat.child.prices.price8,
                                childExpCur:  res.prices.costExpat.child.currency
                            }
                        })
                    }
                })
            },
            changeCurrency(data){
                this.data[data.name] = data.value
            },
            changeValue(data){
                this.data[data.name] = data.value
            },
            createActivityPriceHandler(){
                createActivityPrice(this.user.access_token, this.seasons.find(item => item.active).id, this.tanzania.id, {
                    "costEA": {
                        "child": {
                            "currency": this.data.childSACur,
                            "prices": {
                                price1: +this.data.childSA1,
                                price2: +this.data.childSA2,
                                price3: +this.data.childSA3,
                                price4: +this.data.childSA4,
                                price5: +this.data.childSA5,
                                price6: +this.data.childSA6,
                                price7: +this.data.childSA7,
                                price8: +this.data.childSA8,
                            }
                        },
                        "teenager": {
                            "currency": this.data.teenSACur,
                            "prices": {
                                price1: +this.data.teenSA1,
                                price2: +this.data.teenSA2,
                                price3: +this.data.teenSA3,
                                price4: +this.data.teenSA4,
                                price5: +this.data.teenSA5,
                                price6: +this.data.teenSA6,
                                price7: +this.data.teenSA7,
                                price8: +this.data.teenSA8,
                            }
                        },
                        "adult": {
                            "currency": this.data.adultSACur,
                            "prices": {
                                price1: +this.data.adultSA1,
                                price2: +this.data.adultSA2,
                                price3: +this.data.adultSA3,
                                price4: +this.data.adultSA4,
                                price5: +this.data.adultSA5,
                                price6: +this.data.adultSA6,
                                price7: +this.data.adultSA7,
                                price8: +this.data.adultSA8,
                            }
                        }
                    },
                    "costForeign": {
                        "child": {
                            "currency": this.data.childForCur,
                            "prices": {
                                price1: +this.data.childFor1,
                                price2: +this.data.childFor2,
                                price3: +this.data.childFor3,
                                price4: +this.data.childFor4,
                                price5: +this.data.childFor5,
                                price6: +this.data.childFor6,
                                price7: +this.data.childFor7,
                                price8: +this.data.childFor8,
                            }
                        },
                        "teenager": {
                            "currency": this.data.teenForCur,
                            "prices": {
                                price1: +this.data.teenFor1,
                                price2: +this.data.teenFor2,
                                price3: +this.data.teenFor3,
                                price4: +this.data.teenFor4,
                                price5: +this.data.teenFor5,
                                price6: +this.data.teenFor6,
                                price7: +this.data.teenFor7,
                                price8: +this.data.teenFor8,
                            }
                        },
                        "adult": {
                            "currency": this.data.adultForCur,
                            "prices": {
                                price1: +this.data.adultFor1,
                                price2: +this.data.adultFor2,
                                price3: +this.data.adultFor3,
                                price4: +this.data.adultFor4,
                                price5: +this.data.adultFor5,
                                price6: +this.data.adultFor6,
                                price7: +this.data.adultFor7,
                                price8: +this.data.adultFor8,
                            }
                        }
                    },
                    "costExpat": {
                        "child": {
                            "currency": this.data.childExpCur,
                            "prices": {
                                price1: +this.data.childExp1,
                                price2: +this.data.childExp2,
                                price3: +this.data.childExp3,
                                price4: +this.data.childExp4,
                                price5: +this.data.childExp5,
                                price6: +this.data.childExp6,
                                price7: +this.data.childExp7,
                                price8: +this.data.childExp8,
                            }
                        },
                        "teenager": {
                            "currency": this.data.teenExpCur,
                            "prices": {
                                price1: +this.data.teenExp1,
                                price2: +this.data.teenExp2,
                                price3: +this.data.teenExp3,
                                price4: +this.data.teenExp4,
                                price5: +this.data.teenExp5,
                                price6: +this.data.teenExp6,
                                price7: +this.data.teenExp7,
                                price8: +this.data.teenExp8,
                            }
                        },
                        "adult": {
                            "currency": this.data.adultExpCur,
                            "prices": {
                                price1: +this.data.adultExp1,
                                price2: +this.data.adultExp2,
                                price3: +this.data.adultExp3,
                                price4: +this.data.adultExp4,
                                price5: +this.data.adultExp5,
                                price6: +this.data.adultExp6,
                                price7: +this.data.adultExp7,
                                price8: +this.data.adultExp8,
                            }
                        }
                    }
                }, 'mainland')
                .then(res => {
                    this.$router.back()
                })
            },
            copyPriceHandler(){
                getTanzaniaPriceCopy(this.user.access_token, this.seasonsData.find(item => item.active).id, this.seasons.find(item => item.active).id, this.tanzania.id)
                .then(res => {
                    this.data = {
                        adultSA1: res.prices.costEA.adult.prices.price1,
                        adultSA2: res.prices.costEA.adult.prices.price2,
                        adultSA3: res.prices.costEA.adult.prices.price3,
                        adultSA4: res.prices.costEA.adult.prices.price4,
                        adultSA5: res.prices.costEA.adult.prices.price5,
                        adultSA6: res.prices.costEA.adult.prices.price6,
                        adultSA7: res.prices.costEA.adult.prices.price7,
                        adultSA8: res.prices.costEA.adult.prices.price8,
                        adultSACur: res.prices.costEA.adult.currency,
                        teenSA1: res.prices.costEA.teenager.prices.price1,
                        teenSA2: res.prices.costEA.teenager.prices.price2,
                        teenSA3: res.prices.costEA.teenager.prices.price3,
                        teenSA4: res.prices.costEA.teenager.prices.price4,
                        teenSA5: res.prices.costEA.teenager.prices.price5,
                        teenSA6: res.prices.costEA.teenager.prices.price6,
                        teenSA7: res.prices.costEA.teenager.prices.price7,
                        teenSA8: res.prices.costEA.teenager.prices.price8,
                        teenSACur:  res.prices.costEA.teenager.currency,
                        childSA1: res.prices.costEA.child.prices.price1,
                        childSA2: res.prices.costEA.child.prices.price2,
                        childSA3: res.prices.costEA.child.prices.price3,
                        childSA4: res.prices.costEA.child.prices.price4,
                        childSA5: res.prices.costEA.child.prices.price5,
                        childSA6: res.prices.costEA.child.prices.price6,
                        childSA7: res.prices.costEA.child.prices.price7,
                        childSA8: res.prices.costEA.child.prices.price8,
                        childSACur: res.prices.costEA.child.currency,
                        adultFor1: res.prices.costForeign.adult.prices.price1,
                        adultFor2: res.prices.costForeign.adult.prices.price2,
                        adultFor3: res.prices.costForeign.adult.prices.price3,
                        adultFor4: res.prices.costForeign.adult.prices.price4,
                        adultFor5: res.prices.costForeign.adult.prices.price5,
                        adultFor6: res.prices.costForeign.adult.prices.price6,
                        adultFor7: res.prices.costForeign.adult.prices.price7,
                        adultFor8: res.prices.costForeign.adult.prices.price8,
                        adultForCur: res.prices.costForeign.adult.currency,
                        teenFor1: res.prices.costForeign.teenager.prices.price1,
                        teenFor2: res.prices.costForeign.teenager.prices.price2,
                        teenFor3: res.prices.costForeign.teenager.prices.price3,
                        teenFor4: res.prices.costForeign.teenager.prices.price4,
                        teenFor5: res.prices.costForeign.teenager.prices.price5,
                        teenFor6: res.prices.costForeign.teenager.prices.price6,
                        teenFor7: res.prices.costForeign.teenager.prices.price7,
                        teenFor8: res.prices.costForeign.teenager.prices.price8,
                        teenForCur: res.prices.costForeign.teenager.currency,
                        childFor1: res.prices.costForeign.child.prices.price1,
                        childFor2: res.prices.costForeign.child.prices.price2,
                        childFor3: res.prices.costForeign.child.prices.price3,
                        childFor4: res.prices.costForeign.child.prices.price4,
                        childFor5: res.prices.costForeign.child.prices.price5,
                        childFor6: res.prices.costForeign.child.prices.price6,
                        childFor7: res.prices.costForeign.child.prices.price7,
                        childFor8: res.prices.costForeign.child.prices.price8,
                        childForCur:  res.prices.costForeign.child.currency,
                        adultExp1: res.prices.costExpat.adult.prices.price1,
                        adultExp2: res.prices.costExpat.adult.prices.price2,
                        adultExp3: res.prices.costExpat.adult.prices.price3,
                        adultExp4: res.prices.costExpat.adult.prices.price4,
                        adultExp5: res.prices.costExpat.adult.prices.price5,
                        adultExp6: res.prices.costExpat.adult.prices.price6,
                        adultExp7: res.prices.costExpat.adult.prices.price7,
                        adultExp8: res.prices.costExpat.adult.prices.price8,
                        adultExpCur:  res.prices.costExpat.adult.currency,
                        teenExp1: res.prices.costExpat.teenager.prices.price1,
                        teenExp2: res.prices.costExpat.teenager.prices.price2,
                        teenExp3: res.prices.costExpat.teenager.prices.price3,
                        teenExp4: res.prices.costExpat.teenager.prices.price4,
                        teenExp5: res.prices.costExpat.teenager.prices.price5,
                        teenExp6: res.prices.costExpat.teenager.prices.price6,
                        teenExp7: res.prices.costExpat.teenager.prices.price7,
                        teenExp8: res.prices.costExpat.teenager.prices.price8,
                        teenExpCur: res.prices.costExpat.teenager.currency,
                        childExp1: res.prices.costExpat.child.prices.price1,
                        childExp2: res.prices.costExpat.child.prices.price2,
                        childExp3: res.prices.costExpat.child.prices.price3,
                        childExp4: res.prices.costExpat.child.prices.price4,
                        childExp5: res.prices.costExpat.child.prices.price5,
                        childExp6: res.prices.costExpat.child.prices.price6,
                        childExp7: res.prices.costExpat.child.prices.price7,
                        childExp8: res.prices.costExpat.child.prices.price8,
                        childExpCur:  res.prices.costExpat.child.currency
                    }
                    this.copySeason = false
                })
            }
        },
        mounted(){
            this.updateData()
            window.addEventListener('click', event => {
                if(!event.target.closest('.edit-popup') && !event.target.closest('.btn')){
                    this.copySeason = false
                }
                if(!event.target.closest('.select-wrapper')){
                    this.selects = {
                        seasons: false,
                        seasonsData: false,
                        park: false
                    }
                }
            })
            const onClickOutside = e => {
                this.selects = {
                    seasons:  this.$el.contains(e.target) && this.selects.seasons,
                    seasonsData:  this.$el.contains(e.target) && this.selects.seasonsData,
                    park:  this.$el.contains(e.target) && this.selects.park
                }
            };
            document.addEventListener('click', onClickOutside);
            this.$on('hook:beforeDestroy', () => document.removeEventListener('click', onClickOutside));
        },
        watch: {
            seasons(){
                if(this.tanzania){
                    getTanzaniaPrice(this.user.access_token, this.seasons.find(item => item.active).id, this.tanzania.id)
                    .then(res => {
                        this.data = {
                            adultSA1: res.prices.costEA.adult.prices.price1,
                            adultSA2: res.prices.costEA.adult.prices.price2,
                            adultSA3: res.prices.costEA.adult.prices.price3,
                            adultSA4: res.prices.costEA.adult.prices.price4,
                            adultSA5: res.prices.costEA.adult.prices.price5,
                            adultSA6: res.prices.costEA.adult.prices.price6,
                            adultSA7: res.prices.costEA.adult.prices.price7,
                            adultSA8: res.prices.costEA.adult.prices.price8,
                            adultSACur: res.prices.costEA.adult.currency,
                            teenSA1: res.prices.costEA.teenager.prices.price1,
                            teenSA2: res.prices.costEA.teenager.prices.price2,
                            teenSA3: res.prices.costEA.teenager.prices.price3,
                            teenSA4: res.prices.costEA.teenager.prices.price4,
                            teenSA5: res.prices.costEA.teenager.prices.price5,
                            teenSA6: res.prices.costEA.teenager.prices.price6,
                            teenSA7: res.prices.costEA.teenager.prices.price7,
                            teenSA8: res.prices.costEA.teenager.prices.price8,
                            teenSACur:  res.prices.costEA.teenager.currency,
                            childSA1: res.prices.costEA.child.prices.price1,
                            childSA2: res.prices.costEA.child.prices.price2,
                            childSA3: res.prices.costEA.child.prices.price3,
                            childSA4: res.prices.costEA.child.prices.price4,
                            childSA5: res.prices.costEA.child.prices.price5,
                            childSA6: res.prices.costEA.child.prices.price6,
                            childSA7: res.prices.costEA.child.prices.price7,
                            childSA8: res.prices.costEA.child.prices.price8,
                            childSACur: res.prices.costEA.child.currency,
                            adultFor1: res.prices.costForeign.adult.prices.price1,
                            adultFor2: res.prices.costForeign.adult.prices.price2,
                            adultFor3: res.prices.costForeign.adult.prices.price3,
                            adultFor4: res.prices.costForeign.adult.prices.price4,
                            adultFor5: res.prices.costForeign.adult.prices.price5,
                            adultFor6: res.prices.costForeign.adult.prices.price6,
                            adultFor7: res.prices.costForeign.adult.prices.price7,
                            adultFor8: res.prices.costForeign.adult.prices.price8,
                            adultForCur: res.prices.costForeign.adult.currency,
                            teenFor1: res.prices.costForeign.teenager.prices.price1,
                            teenFor2: res.prices.costForeign.teenager.prices.price2,
                            teenFor3: res.prices.costForeign.teenager.prices.price3,
                            teenFor4: res.prices.costForeign.teenager.prices.price4,
                            teenFor5: res.prices.costForeign.teenager.prices.price5,
                            teenFor6: res.prices.costForeign.teenager.prices.price6,
                            teenFor7: res.prices.costForeign.teenager.prices.price7,
                            teenFor8: res.prices.costForeign.teenager.prices.price8,
                            teenForCur: res.prices.costForeign.teenager.currency,
                            childFor1: res.prices.costForeign.child.prices.price1,
                            childFor2: res.prices.costForeign.child.prices.price2,
                            childFor3: res.prices.costForeign.child.prices.price3,
                            childFor4: res.prices.costForeign.child.prices.price4,
                            childFor5: res.prices.costForeign.child.prices.price5,
                            childFor6: res.prices.costForeign.child.prices.price6,
                            childFor7: res.prices.costForeign.child.prices.price7,
                            childFor8: res.prices.costForeign.child.prices.price8,
                            childForCur:  res.prices.costForeign.child.currency,
                            adultExp1: res.prices.costExpat.adult.prices.price1,
                            adultExp2: res.prices.costExpat.adult.prices.price2,
                            adultExp3: res.prices.costExpat.adult.prices.price3,
                            adultExp4: res.prices.costExpat.adult.prices.price4,
                            adultExp5: res.prices.costExpat.adult.prices.price5,
                            adultExp6: res.prices.costExpat.adult.prices.price6,
                            adultExp7: res.prices.costExpat.adult.prices.price7,
                            adultExp8: res.prices.costExpat.adult.prices.price8,
                            adultExpCur:  res.prices.costExpat.adult.currency,
                            teenExp1: res.prices.costExpat.teenager.prices.price1,
                            teenExp2: res.prices.costExpat.teenager.prices.price2,
                            teenExp3: res.prices.costExpat.teenager.prices.price3,
                            teenExp4: res.prices.costExpat.teenager.prices.price4,
                            teenExp5: res.prices.costExpat.teenager.prices.price5,
                            teenExp6: res.prices.costExpat.teenager.prices.price6,
                            teenExp7: res.prices.costExpat.teenager.prices.price7,
                            teenExp8: res.prices.costExpat.teenager.prices.price8,
                            teenExpCur: res.prices.costExpat.teenager.currency,
                            childExp1: res.prices.costExpat.child.prices.price1,
                            childExp2: res.prices.costExpat.child.prices.price2,
                            childExp3: res.prices.costExpat.child.prices.price3,
                            childExp4: res.prices.costExpat.child.prices.price4,
                            childExp5: res.prices.costExpat.child.prices.price5,
                            childExp6: res.prices.costExpat.child.prices.price6,
                            childExp7: res.prices.costExpat.child.prices.price7,
                            childExp8: res.prices.costExpat.child.prices.price8,
                            childExpCur:  res.prices.costExpat.child.currency
                        }
                    })
                    .catch(() => {
                        this.data = {
                            adultSA1: '',
                            adultSA2: '',
                            adultSA3: '',
                            adultSA4: '',
                            adultSA5: '',
                            adultSA6: '',
                            adultSA7: '',
                            adultSA8: '',
                            adultSACur: 'USD',
                            teenSA1: '',
                            teenSA2: '',
                            teenSA3: '',
                            teenSA4: '',
                            teenSA5: '',
                            teenSA6: '',
                            teenSA7: '',
                            teenSA8: '',
                            teenSACur: 'USD',
                            childSA1: '',
                            childSA2: '',
                            childSA3: '',
                            childSA4: '',
                            childSA5: '',
                            childSA6: '',
                            childSA7: '',
                            childSA8: '',
                            childSACur: 'USD',
                            adultFor1: '',
                            adultFor2: '',
                            adultFor3: '',
                            adultFor4: '',
                            adultFor5: '',
                            adultFor6: '',
                            adultFor7: '',
                            adultFor8: '',
                            adultForCur: 'USD',
                            teenFor1: '',
                            teenFor2: '',
                            teenFor3: '',
                            teenFor4: '',
                            teenFor5: '',
                            teenFor6: '',
                            teenFor7: '',
                            teenFor8: '',
                            teenForCur: 'USD',
                            childFor1: '',
                            childFor2: '',
                            childFor3: '',
                            childFor4: '',
                            childFor5: '',
                            childFor6: '',
                            childFor7: '',
                            childFor8: '',
                            childForCur: 'USD',
                            adultExp1: '',
                            adultExp2: '',
                            adultExp3: '',
                            adultExp4: '',
                            adultExp5: '',
                            adultExp6: '',
                            adultExp7: '',
                            adultExp8: '',
                            adultExpCur: 'USD',
                            teenExp1: '',
                            teenExp2: '',
                            teenExp3: '',
                            teenExp4: '',
                            teenExp5: '',
                            teenExp6: '',
                            teenExp7: '',
                            teenExp8: '',
                            teenExpCur: 'USD',
                            childExp1: '',
                            childExp2: '',
                            childExp3: '',
                            childExp4: '',
                            childExp5: '',
                            childExp6: '',
                            childExp7: '',
                            childExp8: '',
                            childExpCur: 'USD'
                        }
                    })
                }
            },
            tanzania(){
                this.updateData()
            },
            save(){
                this.createActivityPriceHandler()
            },
            isOpenSeasons(){
                this.updateData()
            }
        }
    }
</script>
